/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation
import React, {Component} from "react";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Kush Vora",
  title: "Hi all, I'm Kush",
  subTitle:
    "A motivated and driven graduate student with a strong interest in creating cutting-edge solutions to tackle pressing challenges across various domains.",
  resumeLink:
    "https://drive.google.com/file/d/17hDz0g2j-B6uPUM4bkmdznxJiHVqFPnw/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/kushv16",
  linkedin: "https://www.linkedin.com/in/kushv16/",
  gmail: "vorakush@gmail.com",
  leetcode: "https://leetcode.com/kushv1608/",
  scholar: "https://scholar.google.com/citations?user=-R9p-zUAAAAJ&hl=en",
  kaggle: "https://www.kaggle.com/kushv16",
  instagram: "https://www.instagram.com/kushv16",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do?",
  subTitle: "Leveraging technology to solve complex real-world problems",
  skills: [
    "Collaborating with cross-functional teams to gather requirements, design, and implement AI-driven models for a wide range of deep learning and statistical use cases",
    "Utilizing frameworks like Django, NextJS to architect and develop full-stack applications, ensuring seamless integration of frontend and backend functionalities.",
    "Implementing effective database management strategies, including data modeling, optimization, and security measures to ensure data integrity and performance.",
    "Configuring cloud-based deployments using platforms like AWS or Google Cloud Platform, enabling scalability, availability, and cost-efficiency of the applications."
  ],
  softwareSkills: [
    {
      skillName: "Python",
      src: "python.png"
    },
    {
      skillName: "JavaScript",
      src: "js.png"
    },
    {
      skillName: "TypeScript",
      src: "typescript.png"
    },
    {
      skillName: "HTML5",
      src: "html5.png"
    },
    {
      skillName: "CSS3",
      src: "css3.png"
    },
    {
      skillName: "Bootstrap",
      src: "bootstrap.png"
    },
    {
      skillName: "Java",
      src: "java-resize.png"
    },
    {
      skillName: "ReactJS",
      src: "reactjs.png"
    },
    {
      skillName: "NextJS",
      src: "nextjs.png"
    },
    {
      skillName: "ReduxJS",
      src: "redux.png"
    },
    {
      skillName: "Django",
      src: "django.png"
    },
    {
      skillName: "NodeJS",
      src: "node_1.png"
    },
    {
      skillName: "Git",
      src: "git.png"
    },
    {
      skillName: "Tensorflow",
      src: "tensorflow.png"
    },
    {
      skillName: "Pytorch",
      src: "pytorch.png"
    },
    {
      skillName: "Heroku",
      src: "heroku.png"
    },
    {
      skillName: "Supabase",
      src: "supabase.png"
    },
    {
      skillName: "MySQL",
      src: "mysql.png"
    },
    {
      skillName: "Prisma ORM",
      src: "prisma.png"
    },
    {
      skillName: "PostgreSQL",
      src: "postgres.png"
    },
    {
      skillName: "Google Cloud",
      src: "gcp.png"
    },
    {
      skillName: "AWS Amplify",
      src: "aws-amplify.png"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Deep Learning",
      progressPercentage: "80%"
    },
    {
      Stack: "Problem Solving", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Full stack development",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};
// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Pennsylvania State University, University Park",
      logo: require("./assets/images/psu.png"),
      subHeader: "Masters of Science in Computer Science and Engineering",
      duration: "August 2023 - May 2025",
      desc: "",
      descBullets: [
        "GPA: 4.00/4.00",
        "Fall 2023 Courses: Distributed Systems, Computer Architecture, Systems for Privacy Preserving Machine Learning"
        // "Led and organized the Google Cloud Program in the college as a campus facilitator",
        // "Worked as a research intern under the mentorship of Dr. Ninad Mehendale",
        // "Worked on 2 research projects under the guidance of Dr. Deepak Sharma",
        // "Department Rank 2 in Semester 4",
        // "Studied core computer science topics like Data Structures, Algorithms, Operating Systems, Databases, etc."
      ]
    },
    {
      schoolName: "K.J. Somaiya College Of Engineering (Mumbai University)",
      logo: require("./assets/images/somaiya.jpg"),
      subHeader: "Bachelors of Technology in Computer Engineering",
      duration: "August 2019 - June 2023",
      desc: "",
      descBullets: [
        "GPA: 3.65/4.00",
        "Led and organized the Google Cloud Program in the college as a campus facilitator",
        "Worked as a research intern under the mentorship of Dr. Ninad Mehendale",
        "Worked on 2 research projects under the guidance of Dr. Deepak Sharma",
        "Department Rank 2 in Semester 4 and Semester 8",
        "Studied core computer science topics like Data Structures, Algorithms, Operating Systems, Databases, etc."
      ]
    },
    // {
    //   schoolName: "K.J. Somaiya College Of Science and Commerce, Mumbai",
    //   logo: require("./assets/images/somaiya.jpg"),
    //   subHeader: "Higher Secondary Degree",
    //   duration: "2017 - 2019",
    //   desc: "",
    //   descBullets: [
    //     "99.11 percentile in Maharashtra Common Enterance Test",
    //     "87.08% in Higher Secondary Examination",
    //     "Studied subjects like C++, Visual Basics, Microprocessors, etc"
    //   ]
    // },
    // {
    //   schoolName: "Fatima High School, Mumbai",
    //   logo: require("./assets/images/fhs.png"),
    //   subHeader: "Matriculate Degree",
    //   duration: "2005 - 2017",
    //   desc: "",
    //   descBullets: [
    //     "92.80 % in the final Matriculation Examination",
    //     "School Topper in Mathematics in the final Matriculation Examination (98/100)"
    //   ]
    // }
  ]
};

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      subHeader: "Pennsylvania State University",
      schoolName: "Teaching Assistant",
      logo: require("./assets/images/psu.png"),
      duration: "September 2023 - Present",
      desc: "TA for CMPSC221 (Object Oriented Programming with Web-Based Application)",
      descBullets: [
        "Responsibilities: Conducting recitation sections, holding office hours, and grading assignments."
      ]
    },
    {
      subHeader: "NxtBig Software Labs Pvt Ltd.",
      schoolName: "Full Stack Software Developer",
      logo: require("./assets/images/nxtbig_white.png"),
      duration: "January 2023 - June 2023",
      desc: "Project: Finkit's E-Commerce Platform",
      descBullets: [
        "Developed a headless e-commerce platform (SaaS) in TypeScript using NextJS, Prisma ORM, and Supabase, specifically tailored to offer comprehensive Income Tax Filing services.",
        "Designed and optimized the system’s database, implementing normalization techniques that reduced data redundancy by nearly 40% and improved query execution time by 25%",
        "Leveraged X-state library to create and execute finite state machines, effectively managing various internal application states",
        "Integrated Zoho and other third-party services, facilitating streamlined and efficient two-way communication between the application and external systems using webhooks and REST APIs"
      ]
    },
    {
      subHeader: "Symbl.ai",
      schoolName: "Github Extern '22 (Winter Cohort)",
      logo: require("./assets/images/github_logo.png"),
      duration: "February 2022 - May 2022",
      desc: "Worked in the R&D Department",
      descBullets: [
        "Selected as a Github Extern from over 14,000 applications and interned at a Github Partner Organization – Symbl.ai",
        "Created an OpenAPI Specification in YAML for Symbl’s asynchronous streaming and telephonic APIs",
        "Developed an API Playground using Redocly for testing Symbl’s Conversation Intelligence APIs",
        "Created a CI/CD pipeline for consistently deploying the updated version of the software to the testing environment",
        "Revamped the website of Symbl.ai by creating reusable components in ReactJS",
        "Improved the SEO of the documentation website using Docusaurus meta tags"
      ]
    },
    {
      subHeader: "Dr. Ninad Mehendale, K.J. Somaiya College Of Engineering",
      schoolName: "Research Intern",
      logo: require("./assets/images/somaiya.jpg"),
      duration: "November 2021 - May 2022",
      desc: "Project: Exudate Segmentation in fundus images",
      descBullets: [
        "Conducted a research on exudate segmentation from eye scans of patients, suffering from Diabetic Retinopathy",
        "Applied Contrast Limited Adaptive Histogram Equalization (CLAHE) to improve the contrast of the fundus images",
        "Performed quantitative comparison of different U-Net architectures on three benchmark datasets viz. IDRiD, E-Optha, and DiaretDB",
        "Evaluated the performance of the neural networks at pixel level, lesion level, and image level",
        "Designed a residual recurrent U-Net (R2-UNet) that segmented exudates with 93.20% sensitivity and 99.80% specificity (lesion level metrics)"
      ]
    },
    {
      subHeader: "Nxt Big Software Labs Pvt. Ltd.",
      schoolName: "Software Developer Intern",
      logo: require("./assets/images/nxtbig_white.png"),
      duration: "April 2021 - June 2021",
      desc: "Project: Finkit & Taxfox (Income tax filing intermediary)",
      descBullets: [
        "Created an end-to-end pipeline for converting JSON Schema provided by the Income Tax Department into fully customizable surveys",
        "Developed a script that reverse maps the user-fed data into nested key-value pairs corresponding to the schema hierarchy",
        "Remodeled the surveys by developing a Node Script that divides the questionnaires into smaller independent surveys",
        "Embedded tax computations and validations to the survey questions by writing JavaScript functions",
        "Developed a React-Redux application for testing and comparing the performance of the generated surveys with previously deployed versions",
        "The optimized system improved the response-time of the software by nearly 70%"
      ]
    },
    {
      subHeader: "Google Developer Student Clubs",
      schoolName: "Google Cloud Campus Facilitator",
      logo: require("./assets/images/gcloud.png"),
      duration: "September 2021 - December 2021",
      desc: "",
      descBullets: [
        `Acted as a liaison between the student community and Google Cloud, advocating for the adoption and utilization of GCP tools and services within the campus ecosystem`,
        `Led and orchestrated the '30 days of Google Cloud Program' on my campus, which had over 250 student enrolments`,
        `Conducted workshops and mentored students on the Google Cloud Platform (GCP), covering various aspects and features of the platform`,
        "Held office hours to provide assistance and clear doubts for students, ensuring their understanding and proficiency in utilizing GCP",
        "Collaborated with fellow facilitators across the globe and the Google Cloud team to create engaging and informative learning materials and resources for the program participants."
      ]
    }
  ]
};

const researchPapers = {
  display: true,
  subtitle:
    "RESEARCH WORK AIMED AT IMPROVING THE HEALTHCARE INDUSTRY USING AI",
  papers: [
    {
      publisher: (
        <>
          <a
            href="https://ieeexplore.ieee.org/abstract/document/10039514"
            target="_blank"
          >
            Published
          </a>{" "}
          in the proceedings of the 5th International Conference on Advances in
          Science and Technology by IEEE(IEEE-ICAST 2022). Pages: 615-621
        </>
      ),
      paperTitle:
        "Hybrid CNN-LSTM network to detect Dysarthria using Mel-Frequency Cepstral Coefficients",
      authors: (
        <>
          <b>Kush V.</b>, Dishant P., Darshil M., Deepak S.
        </>
      )
    },
    {
      publisher: (
        <>
          Pre-print available at Techrxiv - IEEE{" "}
          <a
            href="https://www.techrxiv.org/articles/preprint/A_deep_learning_based_approach_to_segment_exudates_in_retinal_fundus_images_using_Recurrent_Residual_U-Net/21196657"
            target="_blank"
          >
            (21196657)
          </a>
        </>
      ),
      paperTitle:
        "A deep learning based approach to segment exudates in retinal fundus images using Recurrent Residual U-Net",
      authors: (
        <>
          <b>Kush V.</b>, Darshil M., Divesh T., Ninad M.
        </>
      )
    },
    {
      publisher: (
        <>
          <a
            href="https://ieeexplore.ieee.org/abstract/document/10039666/"
            target="_blank"
          >
            Published
          </a>{" "}
          in the proceedings of the 5th International Conference on Advances in
          Science and Technology by IEEE(IEEE-ICAST 2022). Pages: 491-496
        </>
      ),
      paperTitle:
        "An Attention U-Net for Semantic Segmentation of Dental Panoramic X-ray images",
      authors: (
        <>
          Dishant P., <b>Kush V.</b>, Deepak S.
        </>
      )
    },
    {
      publisher: (
        <>
          <a
            href="https://ieeexplore.ieee.org/abstract/document/10039653/"
            target="_blank"
          >
            Published
          </a>{" "}
          in the proceedings of the 5th International Conference on Advances in
          Science and Technology by IEEE(IEEE-ICAST 2022). Pages: 306-313
        </>
      ),
      paperTitle:
        "MRI Image Denoising using U-Net and Image Processing Techniques",
      authors: (
        <>
          Darshil M., Dishant P., <b>Kush V.</b>, Ninad M.
        </>
      )
    },
    {
      publisher: (
        <>
          Pre-print available at SSRN - Elsevier{" "}
          <a
            href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4220435"
            target="_blank"
          >
            (Abstract ID: 4220435)
          </a>
          <br></br>
          Distributed in 'Radiology Medical Imaging' eJournal by SSRN -
          Elsevier, Vol 4, Issue 72, December 06, 2022
        </>
      ),
      paperTitle:
        "EEF-Net: An Enhanced EfficientNet for Breast Tumor Classification in Mammograms",
      authors: (
        <>
          Dishant P., <b>Kush V.</b>, Darshil M., Ninad M.
        </>
      )
    },
    {
      publisher: (
        <>
          Pre-print available at Arxiv{" "}
          <a href="https://arxiv.org/abs/2210.00298" target="_blank">
            (2210.00298)
          </a>
        </>
      ),
      paperTitle:
        "An Ensemble of Convolutional Neural Networks to Detect Foliar Diseases in Apple Plants",
      authors: (
        <>
          <b>Kush V.</b>, Dishant P.
        </>
      )
    }
  ]
};
const hackathon = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      subHeader:
        "24-hour hackathon organized by Computer Society of India - KJSCE",
      schoolName: "Hackerbash Hackathon",
      logo: require("./assets/images/hackerbash_circle.png"),
      duration: "February 2021",
      desc: "",
      descBullets: [
        "Built a geo-application using Python and GeoDjango that helps Indian citizens find the nearest COVID19 vaccination center",
        "Worked as a backend engineer and integrated different user-facing components with APIs and PostgreSQL database by writing server-side logic",
        "Devised an algorithm that locates the user using their IP address and routes them to the nearest vaccination center",
        "Won the 24-hour Hackerbash Hackathon with this project across all development domains (Web Dev/ Application Dev/ IoT)"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECTS DIRECTED TOWARDS SOLVING REAL-WORLD PROBLEMS",
  projects: [
    {
      image: require("./assets/images/mumbai_police.png"),
      projectName: "Mumbai Police Web Application",
      projectDesc: `The Mumbai Police project empowers the people to stay connected with the police and all its facilities, ultimately strengthening law and order in the city. The sole aim of this digital solution is to give more potency to the police, with increased security and efficiency in the system. The portal provides a platform that unifies the people and the police, thereby bolstering the country's legal system..
        `,
      footerLink: [
        // {
        //   name: "View Website",
        //   url: "https://mumbaipolice.herokuapp.com/"
        // },
        {
          name: "Github Repository",
          url: "https://github.com/kushv16/Mumbai_Police"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/covaccine.webp"),
      projectName: "Co-Vaccine",
      projectDesc: `Co-Vaccine bolsters India's Covid-19 vaccination drive by providing a robust interface between vaccination providers and consumers. Users can, in the comfort of their homes, book an appointment to the nearest health center, over a week, based on the availability of the vaccination slots. Co-Vaccine detects the nearest vaccination center and navigates the user there and more!`,
      footerLink: [
        // {
        //   name: "Visit Website",
        //   url: "https://covaccine.herokuapp.com/"
        // },
        {
          name: "Github Repository",
          url: "https://github.com/kushv16/Co_Vaccine"
        }
      ]
    },
    {
      image: require("./assets/images/green_doctor.png"),
      projectName: "Green Doctor",
      projectDesc:
        "Leaf diseases pose a major threat to the overall productivity and quality of the cultivation. Green Doctor, is a one stop application for all the needs of the farmer. The key aspect of our Software is the use of a deep learning model, which is able to detect 38 different type of leaf diseases and recommend remedies to the farmers.",
      footerLink: [
        {
          name: "Github Repository",
          url: "https://github.com/Marmik198/Green_Doctor_MP"
        }
      ]
    },
    {
      image: require("./assets/images/capture_it_colored.jpg"),
      projectName: "Capture IT",
      projectDesc:
        "CaptureIT lets you search what you see and understand the world around you using your camera. The app allows the user to scan images and extract the text from an image along with features such as OCR, translating the text to 100+ languages, scanning QR codes, etc.",
      footerLink: [
        {
          name: "Github Repository",
          url: "https://github.com/kushv16/CaptureIT"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Certifications",
  subtitle:
    "Certifications, Award Letters and Some Cool Stuff that I have done !",
  achievementsCards: [
    {
      title: "Python Programming Bootcamp",
      subtitle: "Sybgen Inc.",
      image: require("./assets/images/sybgenlogo.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/1ErzDsxpLzeThf0GpR-8Od8qoHq39zYro/view?usp=sharing"
        }
      ]
    },
    {
      title: "Google Cloud Program Training",
      subtitle: "Google Developers Student Club",
      image: require("./assets/images/google_logo.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://drive.google.com/file/d/12M7m0yBSw9n9gk8qhQCcxhaYcVPE6vzQ/view?usp=sharing"
        }
      ]
    },
    {
      title: "Machine Learning Course",
      subtitle: "Andrew Ng (Stanford University)",
      image: require("./assets/images/stanford_logo.png"),
      footerLink: [
        {
          name: "Course Link",
          url: "https://www.coursera.org/learn/machine-learning"
        }
      ]
    },
    {
      title: "Deep Learning Specialization",
      subtitle: "Andrew Ng (Stanford University)",
      image: require("./assets/images/deeplearning_ai_logo.png"),
      footerLink: [
        {
          name: "Course Link",
          url: "https://www.coursera.org/specializations/deep-learning"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// const blogSection = {
//   title: "Blogs",
//   subtitle:
//     "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
//   displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
//   blogs: [
//     {
//       url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
//       title:
//         "A deep learning based approach to segment exudates in retinal fundus images using Recurrent Residual U-Net",
//       description:
//         "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
//     },
//     {
//       url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
//       title: "Why REACT is The Best?",
//       description:
//         "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
//     }
//   ],
//   display: true // Set false to hide this section, defaults to true
// };

const contactInfo = {
  title: "Contact Me ",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "vorakush@gmail.com"
};

// Twitter Section

// const twitterDetails = {
//   userName: "twitter", //Replace "twitter" with your twitter username without @
//   display: true // Set true to display this section, defaults to false
// };

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  researchPapers,
  hackathon,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  contactInfo
};
